import React from 'react';
import { CurrencyInput } from 'react-currency-mask';
import { Input } from 'antd';

const MyComponent = ({ handleInput, labelInput, labelError, value, isDisable}) => {
  return (
    <div>
      <CurrencyInput
        onChangeValue={(event, originalValue, maskedValue) => {
          handleInput(originalValue)
        }}
        value={value && value}
        InputElement={
          <Input 
            value={value} 
            placeholder={labelInput} 
            disabled={isDisable ? true : false}
            status={labelError ? "error" : ""}
          />
        }
      />
      {labelError && (
        <div style={{ color: '#ff4d4f', fontSize: '12px', marginTop: '4px' }}>
          {labelError}
        </div>
      )}
    </div>
  );
};

export default MyComponent;